module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Spartan Plumbing Services & Repairs","short_name":"Spartan Plumbing","start_url":"/","background_color":"#0D4D8D","theme_color":"#C32830","display":"minimal-ui","icon":"src/images/Spartan-Logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
